import React from 'react';

import Input from '@nhl/nhl-react-ui/lib/Forms/Input';

import TeamDisplayModule from '../teamDisplayModule';
import { listType } from '../teamsList';
import { teamsByDivisionListPropTypes } from './propTypes';

const TeamsByDivisionList = ({ division, ...props }) => {

    const isFilterList = (props.listType === listType.FILTER_LIST);

    const isDivisionChecked = ((selectedTeams, teamsInDivision) =>
        teamsInDivision.every((team) => selectedTeams.find((selectedTeam) => selectedTeam.id === team.id)));

    const teamsForDivision = division.teams.map(team =>
        <TeamDisplayModule
            key={ team.id }
            team={ team }
            season={ props.season }
            { ...props }
        />
    );

    return (
        <div key={`${division.id}`} className={`division-container ${division.name.toLowerCase()}-division`}>
            <div className="division-header">
                {
                    isFilterList
                        ?   <Input
                                type="checkbox"
                                id={ `${division.id}` }
                                key={ division.id }
                                onChange={ props.teamDisplayProps.changeDivisionSelection }
                                checked={ isDivisionChecked(props.teamDisplayProps.selectedTeams, division.teams) }
                            />
                        :   null
                }
                { `${division.name} Division` }
            </div>
            { teamsForDivision }
        </div>
    )
};

TeamsByDivisionList.propTypes = teamsByDivisionListPropTypes;

export default TeamsByDivisionList
